import { resolveRefundReason } from "@/lib/refundReason";

interface RefundReasonBadgeProps {
  reason: string | null | undefined;
  description?: string | null;
  size?: "xs" | "sm";
}

// 크레딧 내역에서 환불 출처를 한눈에 알 수 있게 보여주는 사유 배지.
export default function RefundReasonBadge({
  reason,
  description = null,
  size = "xs",
}: RefundReasonBadgeProps) {
  const info = resolveRefundReason(reason, description);
  if (!info) return null;

  const sizeCls = size === "sm" ? "px-2.5 py-1 text-[11px] gap-1.5" : "px-2 py-0.5 text-[10px] gap-1";
  const iconCls = size === "sm" ? "text-[11px]" : "text-[10px]";

  return (
    <span
      className={`inline-flex items-center rounded-full border font-semibold whitespace-nowrap ${sizeCls} ${info.cls}`}
    >
      <i className={`${info.icon} ${iconCls}`}></i>
      {info.label}
    </span>
  );
}